import React, { createContext, useContext, useState, useEffect } from 'react';

export const AnalyticsContext = createContext();

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);
  if (!context) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }
  return context;
};

export const AnalyticsProvider = ({ children }) => {
  const [pageViews, setPageViews] = useState([]);
  const [userInteractions, setUserInteractions] = useState([]);
  const [visitDuration, setVisitDuration] = useState(0);
  const [sessionStart, setSessionStart] = useState(null);

  useEffect(() => {
    setSessionStart(Date.now());
    
    const interval = setInterval(() => {
      if (sessionStart) {
        setVisitDuration(Math.floor((Date.now() - sessionStart) / 1000));
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [sessionStart]);

  const trackPageView = (page) => {
    const pageView = {
      page,
      timestamp: Date.now(),
      url: window.location.href,
      referrer: document.referrer
    };
    setPageViews(prev => [...prev, pageView]);
  };

  const trackInteraction = (type, element, data = {}) => {
    const interaction = {
      type,
      element,
      data,
      timestamp: Date.now(),
      page: window.location.pathname
    };
    setUserInteractions(prev => [...prev, interaction]);
  };

  const getAnalytics = () => {
    return {
      totalPageViews: pageViews.length,
      totalInteractions: userInteractions.length,
      visitDuration,
      pageViews,
      userInteractions,
      sessionStart
    };
  };

  const value = {
    pageViews,
    userInteractions,
    visitDuration,
    trackPageView,
    trackInteraction,
    getAnalytics
  };

  return (
    <AnalyticsContext.Provider value={value}>
      {children}
    </AnalyticsContext.Provider>
  );
};